import http from 'conversations-http/clients/http';
import { registerQuery, useQuery } from 'data-fetching-client';
import { useMemo } from 'react';
function fetchPublicViewsService() {
  return http.get('conversations-custom-views/v1/view-management/views/public');
}
const fetchPublicViews = registerQuery({
  fetcher: fetchPublicViewsService,
  fieldName: 'fetchPublicViews'
});
const EMPTY_VIEWS_ARRAY = [];
export const usePublicViews = () => {
  const {
    data,
    error,
    networkStatus
  } = useQuery(fetchPublicViews, {});
  return useMemo(() => {
    var _data$fetchPublicView, _data$fetchPublicView2;
    return {
      views: (_data$fetchPublicView = data === null || data === void 0 || (_data$fetchPublicView2 = data.fetchPublicViews) === null || _data$fetchPublicView2 === void 0 ? void 0 : _data$fetchPublicView2.customViews) !== null && _data$fetchPublicView !== void 0 ? _data$fetchPublicView : EMPTY_VIEWS_ARRAY,
      error,
      networkStatus
    };
  }, [data, error, networkStatus]);
};